import {
  Avatar,
  Box,
  LinearProgress,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { postNotification } from "../../../../components/utilities/Notifications";
import {
  delay,
  findGetParameter,
  getData,
} from "../../../../components/utilities/UtilityFunctions";
import {
  gameSystemNameFromGameType,
  sortGroupData,
} from "../GroupPlayUtilities";
import mappingData from "../demoData/mappingData.json";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";

export default function GroupTop5Box({
  eventId,
  eventGroupId,
  activeTab,
  label,
  gameType,
  groupNamePlural,
  groupName,
  // groupData,
  hideCompleteLeaders,
  appRoute,
}) {
  const [loading, setLoading] = useState(true);
  const [groupData, setGroupData] = useState(null);
  const embed = appRoute || findGetParameter("embed");
  const _darkMode = findGetParameter("darkMode") === "true";
  const _lightMode = findGetParameter("lightMode") === "true";
  const _mode = _darkMode
    ? "&darkMode=true"
    : _lightMode
    ? "&lightMode=true"
    : "";

  const updateData = async (_eventId) => {
    if (_eventId !== eventId) {
      return;
    }
    try {
      var apiData = await getData(
        `/players/gwworlds?groupQuery=${activeTab === 0 ? true : false}${
          eventId
            ? `&eventId=${eventId}`
            : eventGroupId
            ? `&eventGroupId=${eventGroupId}`
            : "&eventGroupId=WorldChamps23"
        }&limit=5`,
        {
          queryStringParameters: {},
        }
      );
      if (apiData?.data?.length) {
        for (let i = 0; i < apiData.data.length; i++) {
          apiData.data[i].name =
            apiData.data[i].label ||
            `${apiData.data[i].firstName} ${apiData.data[i].lastName}`.trim();
          apiData.data[i].countryCode =
            apiData.data[i].countryCode ||
            mappingData[apiData.data[i].label || apiData.data[i].groupName] ||
            apiData.data[i].label ||
            apiData.data[i].groupName;
          apiData.data[i].groupName =
            apiData.data[i].groupName || apiData.data[i].label;
        }

        apiData.data = sortGroupData(apiData.data, "wcwPoints");
      }

      setGroupData(apiData?.data);
    } catch (err) {
      postNotification("error", err);
    }
    setLoading(false);

    await delay(60 * 2.5 * 1000);
    updateData(_eventId);
  };

  useEffect(() => {
    updateData(eventId);
    // eslint-disable-next-line
  }, [eventId]);

  return (
    <Box
      sx={{
        mb: 1,
      }}
    >
      <TableContainer>
        <Table
          sx={{
            "& .MuiTableCell-root": {
              fontSize: "12px",
            },
          }}
        >
          <colgroup>
            <col style={{ width: "calc(100% - 75px)" }} />
            <col style={{ width: "75px" }} />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell align="left" padding="none">
                {label}
              </TableCell>
              <TableCell align="center" padding="none">
                Points
              </TableCell>
            </TableRow>
          </TableHead>
          {loading ? (
            <TableBody sx={{ height: "114px" }}>
              <TableRow sx={{ borderBottom: "unset", verticalAlign: "top" }}>
                <TableCell
                  padding="none"
                  colSpan={2}
                  sx={{ borderBottom: "unset" }}
                >
                  <LinearProgress />
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {groupData?.length > 0 ? (
                groupData.map((group) => {
                  return (
                    <TableRow
                      key={group.name || group.label}
                      sx={{
                        borderBottom: "1px solid rgba(81, 81, 81, 1)",
                      }}
                    >
                      <TableCell
                        padding="none"
                        component="th"
                        scope="row"
                        sx={{
                          width: "calc(100% - 75px)",
                        }}
                      >
                        <span
                          style={{
                            width: "25px",
                            display: "inline-block",
                          }}
                        >
                          {group.place}
                        </span>
                        {activeTab === 0 ? (
                          <Link
                            color="inherit"
                            underline="none"
                            href={`/world-championships-of-warhammer${
                              eventGroupId === "WorldChamps24"
                                ? "-24"
                                : eventGroupId === "WorldChamps23"
                                ? "-23"
                                : ""
                            }/players?countryCode=${
                              group.countryCode
                            }&groupName=${group.groupName}${
                              embed ? `&embed=${embed}` : ""
                            }${_mode}${
                              gameType ? `&gameType=${gameType}` : ""
                            }`}
                          >
                            <Top5Row group={group} activeTab={activeTab} />
                          </Link>
                        ) : group?.armyListId ? (
                          <Link
                            color="inherit"
                            underline="none"
                            href={`/list/${group.armyListId}`}
                            target="_blank"
                          >
                            <Top5Row group={group} activeTab={activeTab} />
                          </Link>
                        ) : (
                          <Top5Row group={group} activeTab={activeTab} />
                        )}
                      </TableCell>

                      <TableCell padding="none" align="center">
                        {group.usedScores?.length > 0 ? (
                          <Tooltip
                            componentsProps={{
                              tooltip: { sx: { maxWidth: "90vw" } },
                            }}
                            title={
                              <Box>
                                {group.usedScores.map((usedPoint, index) => (
                                  <Typography
                                    key={index}
                                    variant="caption"
                                    sx={{ display: "block" }}
                                  >
                                    {usedPoint.playerName}{" "}
                                    {gameSystemNameFromGameType(
                                      usedPoint.gameType
                                    )}{" "}
                                    {usedPoint.category === "Battle"
                                      ? "Generalship"
                                      : usedPoint.category}{" "}
                                    {usedPoint.points}
                                  </Typography>
                                ))}
                              </Box>
                            }
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                              }}
                            >
                              {group.wcwPoints || 0}
                            </Typography>
                          </Tooltip>
                        ) : (
                          <Typography
                            sx={{
                              fontSize: "12px",
                            }}
                          >
                            {group.wcwPoints || 0}
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <></>
              )}
            </TableBody>
          )}

          {!hideCompleteLeaders && (
            <TableFooter>
              <TableRow sx={{ borderBottom: "unset" }}>
                <TableCell
                  padding="none"
                  colSpan={2}
                  sx={{ textAlign: "center", borderBottom: "unset" }}
                >
                  <Link
                    href={`/world-championships-of-warhammer${
                      eventGroupId === "WorldChamps24"
                        ? "-24"
                        : eventGroupId === "WorldChamps23"
                        ? "-23"
                        : ""
                    }/${groupNamePlural.toLowerCase()}?${
                      embed ? `embed=${embed}` : ""
                    }${_mode}${gameType ? `&gameType=${gameType}` : ""}`}
                  >
                    Complete Leaders
                  </Link>
                </TableCell>
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
    </Box>
  );
}

function Top5Row({ group, activeTab }) {
  return (
    <>
      <Box
        sx={{
          display: "inline-block",
          mr: 1,
          paddingTop: "2px",
          // display: "flex", alignItems: "center"
        }}
      >
        <Avatar
          alt={
            group?.name ||
            group?.label ||
            (activeTab === 0 ? "Country" : "Player")
          }
          src={`${getEnvironmentVariable(
            "SYSTEM_IMAGES_CLOUDFRONT"
          )}/system-images/countries/${group.countryCode || group.name}.svg`}
          sx={{
            width: 12,
            height: 12,
            position: "relative",
            top: "2px",
          }}
        />
      </Box>
      <span
        style={{
          display: "inline-block",
          position: "relative",
          top: "4px",
          maxWidth: "calc(100% - 45px)", // 25 + 16

          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {group.name || group.label}
      </span>
    </>
  );
}
